export default {
  name: "language-selection",
  data() {
    return {
      showDialog: false,
      selectedLang: this.$i18n.locale,
      languageList: [
        {
          title: this.$t("languages.farsi"),
          value: "fa"
        },
        {
          title: this.$t("languages.english"),
          value: "en"
        }
        // {
        //   title: this.$t("languages.arabic"),
        //   value: "ar"
        // }
      ]
    };
  },

  // computed: {
  //   showSelected() {
  //     return this.languageList.find((item) => item.value == this.selectedLang);
  //   },
  // },

  methods: {
    confirm(lang) {
      let currentLang = localStorage.getItem("lang");
      if (currentLang == lang.value) {
        return;
      }
      localStorage.setItem("lang", lang.value);
      this.$cookies.set("lang", lang.value);
      this.$router.go();
    }
  }
};
